import { render } from "./rep140.vue?vue&type=template&id=d8691344"
import script from "./rep140.vue?vue&type=script&lang=js"
export * from "./rep140.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__